import { locations } from '~/routes';
import { Location } from '~/types';
import axios, { auth, ResponseType } from './axios';

export const getLocations = (params: any): ResponseType<Location[]> => {
  return axios.get(`/${locations}`, { params });
};

export const getAllLocations = (): ResponseType<Location[]> => {
  return axios.get(`/${locations}`, { params: { page: 1, perPage: 9999 } });
};

export const getLocationById = (id: string) => (): ResponseType<Location> => {
  return axios.get(`/${locations}/${id}`);
};

export const createLocation = (body: Location): ResponseType<Location> => {
  return axios.post(`/${locations}`, { ...body, businessId: auth.getProfile() });
};

export const updateLocation = ({
  id,
  body,
}: {
  id: string;
  body: Location;
}): ResponseType<Location> => {
  return axios.put(`/${locations}/${id}`, body);
};

export const closeLocation = (id: string): ResponseType<any> => {
  return axios.post(`/${locations}/${id}/close`);
};
